import React from "react";

const SPONSOR_SLUG = "nha-tai-tro";

const slugify = (value) => {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

const getMediaCategoryId = (media) => {
  return (
    media?.mediaCategoryId ||
    media?.media_category_id ||
    media?.id_media_category ||
    media?.MediaCategoryId ||
    null
  );
};

const getImageUrl = (image) => {
  return image?.url || image?.imageUrl || image?.image_url || image?.path || "";
};

const SponsorImageSlider = ({ title, images, showTitle = true }) => {
  const validImages = (images || []).filter((image) => getImageUrl(image));

  if (!validImages.length) {
    return null;
  }

  const loopImages =
    validImages.length > 1 ? [...validImages, ...validImages] : validImages;

  return (
    <div className="w-full bg-white py-8 md:py-10 mb-4 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative overflow-hidden">
          <div
            className={`flex items-center gap-12 md:gap-20 ${
              validImages.length > 1 ? "sponsor-marquee-track" : "justify-center"
            }`}
          >
            {loopImages.map((image, index) => {
              const imageUrl = getImageUrl(image);

              return (
                <div
                  key={`${image.id}-${index}`}
                  className="flex-shrink-0 w-36 sm:w-44 md:w-52 lg:w-60 h-24 sm:h-28 md:h-32 lg:h-36 flex items-center justify-center"
                >
                  <img
                    src={imageUrl}
                    alt={
                      image.name ||
                      image.originalName ||
                      title ||
                      "Nhà tài trợ"
                    }
                    className="max-w-full max-h-full object-contain"
                    loading="lazy"
                  />
                </div>
              );
            })}
          </div>
        </div>

        {showTitle && title && (
          <div className="mt-5">
            <h2 className="text-center text-lg md:text-xl font-bold uppercase text-black tracking-wide">
              {title}
            </h2>
            <div className="w-80 max-w-full h-px bg-gray-200 mx-auto mt-6"></div>
          </div>
        )}
      </div>

      <style>
        {`
          .sponsor-marquee-track {
            width: max-content;
            animation: sponsor-marquee 28s linear infinite;
          }

          .sponsor-marquee-track:hover {
            animation-play-state: paused;
          }

          @keyframes sponsor-marquee {
            0% {
              transform: translateX(0);
            }

            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>
  );
};

const SponsorSlider = ({ categories = [], medias = [] }) => {
  const sponsorParent = categories.find(
    (category) =>
      category.slug === SPONSOR_SLUG || slugify(category.name) === SPONSOR_SLUG
  );

  if (!sponsorParent) {
    return null;
  }

  const sponsorChildren = categories
    .filter((category) => Number(category.parentId) === Number(sponsorParent.id))
    .sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));

  const parentImages = medias.filter(
    (media) => Number(getMediaCategoryId(media)) === Number(sponsorParent.id)
  );

  const hasChildImages = sponsorChildren.some((category) =>
    medias.some(
      (media) => Number(getMediaCategoryId(media)) === Number(category.id)
    )
  );

  if (!hasChildImages && !parentImages.length) {
    return null;
  }

  return (
    <div className="mt-3 mb-3 bg-white">
      {sponsorChildren.map((category) => {
        const images = medias.filter(
          (media) => Number(getMediaCategoryId(media)) === Number(category.id)
        );

        return (
          <SponsorImageSlider
            key={category.id}
            title={category.name}
            images={images}
            showTitle={true}
          />
        );
      })}

      <SponsorImageSlider
        title={sponsorParent.name}
        images={parentImages}
        showTitle={false}
      />
    </div>
  );
};

export default SponsorSlider;